import { preCachePreferences } from '@fs/zion-preferences'

export const dismissGettingStartedCardPref = 'treeweb.dismissGettingStartedCard'
export const dismissAddMemoryCardPref = 'treeweb.dismissAddMemoryCard'

// Preload all noteworthy preferences that are used by the app and multiple sub-components to speed up pageloads.
export default function usePreloadPreferences() {
  preCachePreferences(
    'tree.cetTest',
    'tree.groups.startingPersonId',
    'tree.showLDSTempleInfo',
    'tree.showNamesInRomanScript',
    dismissGettingStartedCardPref,
    dismissAddMemoryCardPref
  )
}
